import { FeatureToggleClientService } from 'feature-toggle-client';
const enableRecurrentNotificationMessages = 'enable-recurrent-notification-messages-in-scheduler';
const enableDownloadReport = 'enable-download-report-in-scheduler';
export class SchedulerFeatures {
    static isEnableRecurrentNotificationMessages() {
        const value = FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(enableRecurrentNotificationMessages, this.enableRecurrentNotificationMessagesDefaultValue);
        return value;
    }
    static isEnabledDownloadReport() {
        return FeatureToggleClientService
            .getInstance()
            .isFeatureEnabled(enableDownloadReport, this.enableDownloadReportDefaultValue);
    }
}
SchedulerFeatures.enableRecurrentNotificationMessagesDefaultValue = false;
SchedulerFeatures.enableDownloadReportDefaultValue = false;
